import C from '../../../constants/accounting/receivable/previewInvoice';
import accountingServices from "../../../services/AccountReceivableService";

export const getDetailInvoice = (id) => dispatch => {
    accountingServices.getDetailInvoice(id).then(res => {
        dispatch({type: C.CHANGE_INVOICE_DETAIL, payload: _.get(res, 'data', {})});
    }, (error) => {
        console.log(JSON.stringify(error));
    })
}